import React, { useState, useEffect } from "react";
import Chart from "chart.js/auto";
import Logo from "../Logo/Logo";
import appStoreBadge from "../../assets/download-on-the-app-store-badge.png";
import googlePlayBadge from "../../assets/get-it-on-google-play-badge.png";
import { Link } from "react-router-dom";

const LandingPageNew = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("tab1");

  // Mobile menu toggle
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  // Tab functionality
  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  // Chart setup
  useEffect(() => {
    const ctx = document.getElementById("benefitsChart");
    if (ctx) {
      let chart;
      try {
        chart = new Chart(ctx, {
          type: "bar",
          data: {
            labels: [
              "Ušteda Vremena",
              "Komfor i Udobnost",
              "Pristupačnost",
              "Transparentnost",
            ],
            datasets: [
              {
                label: "Tradicionalni Pristup",
                data: [3, 4, 5, 4],
                backgroundColor: "rgba(128, 128, 128, 0.6)",
                borderColor: "rgba(128, 128, 128, 1)",
                borderWidth: 1,
              },
              {
                label: "apoteka.rs",
                data: [9, 10, 10, 8],
                backgroundColor: "rgba(0, 128, 128, 0.7)",
                borderColor: "rgba(0, 128, 128, 1)",
                borderWidth: 1,
              },
            ],
          },
          options: {
            indexAxis: "y",
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: {
                beginAtZero: true,
                max: 10,
                grid: { color: "rgba(0, 0, 0, 0.05)" },
                ticks: { color: "#555" },
              },
              y: {
                grid: { display: false },
                ticks: { color: "#333", font: { size: 14 } },
              },
            },
            plugins: {
              legend: {
                position: "top",
                labels: { color: "#333", font: { size: 14 } },
              },
              tooltip: {
                enabled: true,
                backgroundColor: "#333",
                titleColor: "#fff",
                bodyColor: "#fff",
                callbacks: {
                  label: function (context) {
                    let label = context.dataset.label || "";
                    if (label) {
                      label += ": ";
                    }
                    if (context.parsed.x !== null) {
                      label += context.parsed.x + " / 10";
                    }
                    return label;
                  },
                },
              },
            },
          },
        });
      } catch (error) {
        console.error("Error initializing Chart.js:", error);
      }

      return () => {
        if (chart) {
          chart.destroy();
        }
      };
    }
  }, []);

  return (
    <div
      className="antialiased"
      style={{
        fontFamily: "Inter, sans-serif",
        backgroundColor: "#FDFCFB",
        color: "#333333",
      }}
    >
      {/* Custom styles for gradient text and tab functionality */}
      <style>{`
        html {
          scroll-behavior: smooth;
        }
        .text-gradient {
          background: linear-gradient(90deg, #01b2b1, #018d8c);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .tab-btn.active {
          border-color: #01b2b1;
          background-color: #e6f7f7;
          color: #018d8c;
          font-weight: 600;
        }
        .tab-content {
          display: none;
        }
        .tab-content.active {
          display: block;
        }
        .step-item:before {
          content: '';
          position: absolute;
          left: 1.25rem;
          top: 2.5rem;
          bottom: -2.5rem;
          width: 2px;
          background-color: #b3e7e7;
          transform: translateX(-50%);
        }
        .step-item:last-child:before {
          display: none;
        }
      `}</style>

      {/* Header & Navigation */}
      <header className="bg-white/80 backdrop-blur-sm sticky top-0 z-50 shadow-sm">
        <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex">
            <Logo />
          </div>
          <div className="hidden md:flex space-x-6 items-center">
            <a
              href="#sta-je"
              className="!text-gray-600 hover:!text-teal-700 transition"
            >
              O nama
            </a>
            <a
              href="#kako-radi"
              className="!text-gray-600 hover:!text-teal-700 transition"
            >
              Kako radi
            </a>
            <a
              href="#funkcionalnosti"
              className="!text-gray-600 hover:!text-teal-700 transition"
            >
              Mogućnosti
            </a>
            <a
              href="#preuzmite"
              className="!bg-teal-600 !text-white px-4 py-2 rounded-lg hover:!bg-teal-700 transition-colors"
            >
              Preuzmite aplikaciju
            </a>
          </div>
          <button
            onClick={toggleMobileMenu}
            className="md:hidden text-gray-700"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              ></path>
            </svg>
          </button>
        </nav>
        {mobileMenuOpen && (
          <div className="md:hidden bg-white px-6 pb-4">
            <a
              href="#sta-je"
              onClick={() => setMobileMenuOpen(false)}
              className="block py-2 !text-gray-600 hover:!text-teal-700"
            >
              O Nama
            </a>
            <a
              href="#kako-radi"
              onClick={() => setMobileMenuOpen(false)}
              className="block py-2 !text-gray-600 hover:!text-teal-700"
            >
              Kako radi
            </a>
            <a
              href="#funkcionalnosti"
              onClick={() => setMobileMenuOpen(false)}
              className="block py-2 !text-gray-600 hover:!text-teal-700"
            >
              Mogućnosti
            </a>
            <a
              href="#preuzmite"
              onClick={() => setMobileMenuOpen(false)}
              className="block mt-2 text-center !bg-teal-600 !text-white px-4 py-2 rounded-lg hover:!bg-teal-700"
            >
              Preuzmite aplikaciju
            </a>
          </div>
        )}
      </header>

      <main>
        {/* Hero Section */}
        <section className="py-20 md:py-32 bg-white">
          <div className="container mx-auto px-6 text-center">
            <h1 className="text-4xl md:text-6xl font-extrabold text-gray-800 mb-4 leading-tight">
              Apoteka u <span className="text-gradient">Vašem domu</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Zaboravite na čekanje i gužve. Naša inovativna platforma je tu da
              promeni način na koji dolazite do neophodnih proizvoda. Omogućili
              smo Vam da brzo, sigurno i jednostavno pronađete sve što Vam treba
              iz apoteka u celoj Srbiji.
            </p>
            <a
              href="#sta-je"
              className="!bg-teal-700 !text-white px-8 py-3 rounded-lg text-lg font-semibold hover:!bg-teal-800 transition-transform transform hover:scale-105"
            >
              Saznajte Više
            </a>
          </div>
        </section>

        {/* What Is Section */}
        <section id="sta-je" className="py-20">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                Šta je apoteka.rs?
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                apoteka.rs je platforma koja Vam omogućava da brzo i jednostavno
                pronađete i rezervišete farmaceutske proizvode, uz mogućnost da
                uvek direktno komunicirate sa farmaceutom. Putem naše platforme
                možete organizovati pomoć oko preuzimanja rezervisanih proizvoda
                i RFZO terapija, koji Vam se isporučuju direktno do vrata,
                upakovani u sigurnosnu kesu. Naša misija je da Vam obezbedimo
                sigurnu, bezbednu i efikasnu uslugu.
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-8 text-center">
              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow border border-gray-100">
                <div className="text-4xl text-teal-600 mb-4">📋</div>
                <h3 className="text-xl font-bold mb-2 text-gray-800">
                  Sve na jednom mestu
                </h3>
                <p className="text-gray-600">
                  Lekovi, suplementi, kozmetika, RFZO terapija i još mnogo toga.
                  Sve se brzo pronađe, lako rezerviše i sortira po
                  najpovoljnijim cenama. Bez bespotrebnog lutanja.
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow border border-gray-100">
                <div className="text-4xl text-teal-600 mb-4">🎁</div>
                <h3 className="text-xl font-bold mb-2 text-gray-800">
                  Loyalty katalog
                </h3>
                <p className="text-gray-600">
                  Jednostavan proces rezervacije u par klikova. Uz svaku
                  kupovinu dobijate loyalty bodove koje možete zameniti za
                  proizvode iz našeg loyalty kataloga.
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow border border-gray-100">
                <div className="text-4xl text-teal-600 mb-4">🏠</div>
                <h3 className="text-xl font-bold mb-2 text-gray-800">
                  Zdravlje Vam kuca na vrata
                </h3>
                <p className="text-gray-600">
                  Volonter donosi terapiju na željenu adresu, u vreme koje Vam
                  odgovara. Sve stiže diskretno upakovano u sigurnosnu kesu, a
                  farmaceut Vam je uvek dostupan za savet putem platforme.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section id="kako-radi" className="py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                Kako funkcioniše?
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Kupovina preko apoteka.rs je brza i laka. Jednostavno pronađite
                željeni proizvod, rezervišite ga online za preuzimanje u apoteci
                ili odaberite da Vam volonter donese na željenu adresu u željeno
                vreme. Svaka Vaša kupovina donosi bodove koje kasnije menjate za
                vredne poklone iz našeg kataloga.
              </p>
            </div>
            <div className="relative max-w-2xl mx-auto">
              <div className="step-item relative pl-16 pb-16">
                <div className="absolute left-0 top-0 flex items-center justify-center w-10 h-10 rounded-full bg-teal-600 text-white font-bold text-xl">
                  1
                </div>
                <h3 className="text-xl font-bold mb-2 text-gray-800">
                  Pretražite
                </h3>
                <p className="text-gray-600">
                  Unesite naziv leka, suplementa ili RFZO terapije i pronađite
                  najpovoljniju ponudu.
                </p>
              </div>
              <div className="step-item relative pl-16 pb-16">
                <div className="absolute left-0 top-0 flex items-center justify-center w-10 h-10 rounded-full bg-teal-600 text-white font-bold text-xl">
                  2
                </div>
                <h3 className="text-xl font-bold mb-2 text-gray-800">
                  Rezervišite
                </h3>
                <p className="text-gray-600">
                  Jednim klikom rezervišite sve proizvode, brzo i bez čekanja.
                </p>
              </div>
              <div className="step-item relative pl-16 pb-16">
                <div className="absolute left-0 top-0 flex items-center justify-center w-10 h-10 rounded-full bg-teal-600 text-white font-bold text-xl">
                  3
                </div>
                <h3 className="text-xl font-bold mb-2 text-gray-800">
                  Sakupljajte bodove
                </h3>
                <p className="text-gray-600">
                  Uz svaku kupovinu dobijate loyalty bodove koje možete zameniti
                  za poklone iz kataloga.
                </p>
              </div>
              <div className="step-item relative pl-16">
                <div className="absolute left-0 top-0 flex items-center justify-center w-10 h-10 rounded-full bg-teal-600 text-white font-bold text-xl">
                  4
                </div>
                <h3 className="text-xl font-bold mb-2 text-gray-800">
                  Dostava na adresu
                </h3>
                <p className="text-gray-600">
                  Volonter donosi lek u sigurnosnoj kesi, u vreme koje Vam
                  odgovara. Uvek imate opciju saveta farmaceuta preko platforme.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Functionalities Section */}
        <section id="funkcionalnosti" className="py-20">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                Šta dobijate sa apoteka.rs
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Iskoristite prednosti apoteka.rs i pojednostavite svoju brigu o
                zdravlju. Brzo, lako i bez gubljenja vremena. Sve što Vam treba,
                dostupno odmah.
              </p>
            </div>

            <div className="max-w-4xl mx-auto">
              <div className="flex flex-wrap justify-center mb-8 border-b border-gray-200">
                <button
                  onClick={() => handleTabClick("tab1")}
                  className={`tab-btn px-4 py-3 text-lg border-b-2 border-transparent transition-colors ${
                    activeTab === "tab1" ? "active" : ""
                  }`}
                >
                  Pretraga i rezervacija
                </button>
                <button
                  onClick={() => handleTabClick("tab2")}
                  className={`tab-btn px-4 py-3 text-lg border-b-2 border-transparent transition-colors ${
                    activeTab === "tab2" ? "active" : ""
                  }`}
                >
                  Dostava i podrška
                </button>
                <button
                  onClick={() => handleTabClick("tab3")}
                  className={`tab-btn px-4 py-3 text-lg border-b-2 border-transparent transition-colors ${
                    activeTab === "tab3" ? "active" : ""
                  }`}
                >
                  Širok asortiman
                </button>
              </div>

              <div className="bg-white rounded-lg p-8 shadow-md border border-gray-100 min-h-[250px]">
                <div
                  className={`tab-content ${
                    activeTab === "tab1" ? "active" : ""
                  }`}
                >
                  <h3 className="text-2xl font-bold mb-4 text-teal-800">
                    Pronađite sve na jednom mestu
                  </h3>
                  <p className="text-gray-600 mb-4">
                    Jednostavno pretražujte lekove, suplemente i kozmetiku.
                    Proverite dostupnost u realnom vremenu i rezervišite online,
                    bez čekanja u redovima.
                  </p>
                  <ul className="list-disc list-inside text-gray-600 space-y-2">
                    <li>
                      <strong>Ušteda vremena:</strong> Izbegnite odlazak od
                      apoteke do apoteke.
                    </li>
                    <li>
                      <strong>Transparentnost:</strong> Lako uporedite proizvode
                      i dostupnost.
                    </li>
                    <li>
                      <strong>Sigurnost:</strong> Vaša rezervacija čeka na
                      preuzimanje u odabranoj apoteci ili Vam je volonter može
                      dostaviti direktno na adresu.
                    </li>
                  </ul>
                </div>
                <div
                  className={`tab-content ${
                    activeTab === "tab2" ? "active" : ""
                  }`}
                >
                  <h3 className="text-2xl font-bold mb-4 text-teal-800">
                    Podrška kada vam je najpotrebnija
                  </h3>
                  <p className="text-gray-600 mb-4">
                    Niste u mogućnosti da lično preuzmete terapiju? Nema
                    problema. Volonter će Vam dostaviti na željenu adresu u
                    željeno vreme.
                  </p>
                  <ul className="list-disc list-inside text-gray-600 space-y-2">
                    <li>
                      <strong>Pristupačnost:</strong> Olakšava pristup
                      farmaceutskih proizvoda svima, posebno onima sa
                      ograničenom mogućnošću kretanja.
                    </li>
                    <li>
                      <strong>Komfor:</strong> Dobijate neophodne proizvode bez
                      napuštanja doma.
                    </li>
                    <li>
                      <strong>Besplatna podrška:</strong> Stručni saveti
                      farmaceuta dostupni vam u svakom trenutku, bez dodatnih
                      troškova.
                    </li>
                  </ul>
                </div>
                <div
                  className={`tab-content ${
                    activeTab === "tab3" ? "active" : ""
                  }`}
                >
                  <h3 className="text-2xl font-bold mb-4 text-teal-800">
                    Sveobuhvatna ponuda
                  </h3>
                  <p className="text-gray-600 mb-4">
                    Pristupite raznovrsnoj ponudi naših partnerskih apoteka, od
                    lekova na recept do proizvoda za svakodnevnu negu.
                  </p>
                  <ul className="list-disc list-inside text-gray-600 space-y-2">
                    <li>Lekovi (sa i bez recepta), suplementi i vitamini</li>
                    <li>Kozmetika i proizvodi za negu celog tela</li>
                    <li>Bebi program i medicinska pomagala</li>
                    <li>I još mnogo toga...</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Chart Section */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                Digitalna apoteka vs. Tradicionalni pristup
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Vizuelizujmo ključne prednosti. Pogledajte kako korišćenje
                apoteka.rs platforme unapređuje Vaše iskustvo u poređenju sa
                klasičnim odlaskom u apoteku.
              </p>
            </div>
            <div className="relative mx-auto w-full max-w-3xl h-80 md:h-96">
              <canvas id="benefitsChart"></canvas>
            </div>
          </div>
        </section>

        {/* Call to Action Section */}
        <section id="preuzmite" className="py-20 bg-teal-700 text-white">
          <div className="container mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Spremni za lakši život?
            </h2>
            <p className="text-lg md:text-xl max-w-2xl mx-auto mb-8 text-teal-100">
              Preuzmite aplikaciju apoteka.rs danas i iskusite budućnost
              farmaceutske nege. Briga o zdravlju nikada nije bila
              jednostavnija.
            </p>
            <div className="flex justify-center space-x-4">
              <a
                href="https://apps.apple.com/rs/app/apoteka-rs/id1642092872"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block transition-transform hover:scale-105"
              >
                <img
                  src={appStoreBadge}
                  alt="Download on the App Store"
                  className="h-12"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=rs.apoteka"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block transition-transform hover:scale-105"
              >
                <img
                  src={googlePlayBadge}
                  alt="Get it on Google Play"
                  className="h-12"
                />
              </a>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-gray-300 py-12">
        <div className="container mx-auto px-6 text-center">
          <p>
            &copy; {new Date().getFullYear()} apoteka.rs | Sva prava zadržana.
          </p>
          <p className="text-sm mt-2">
            Za dodatne informacije pozovite nas besplatno na broj:{" "}
            <a href="tel:0800800700" className="!text-teal-400 hover:underline">
              0800 800 700
            </a>
          </p>
          <div className="flex gap-4 justify-center text-sm mt-2">
            <Link
              to="/PrivacyPolicy"
              onClick={() => window.scrollTo(0, 0)}
              className="!text-teal-400 hover:underline"
            >
              Izjava o privatnosti
            </Link>
            <Link
              to="/TermsOfService"
              onClick={() => window.scrollTo(0, 0)}
              className="!text-teal-400 hover:underline"
            >
              Opšti uslovi korišćenja
            </Link>
            <Link
              to="/misljenje-ministarstva-zdravlja"
              onClick={() => window.scrollTo(0, 0)}
              className="!text-teal-400 hover:underline"
            >
              Mišljenje Ministarstva zdravlja
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPageNew;
